import axios from "axios";
import mainConfig from "/config";
const account = mainConfig.endpoint + "account"

const api = {
    getUserByUsername(token, username) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        let aFormData = new FormData();
        aFormData.append("users_methods", '__get_user_by_username__');
        aFormData.append("username", username);

        return new Promise((resolve, reject) => {
            axios
                .post(account, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp)

                }).catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                });
        });
    },

    updateProfile(data, token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token

            }
        };

        let aFormData = new FormData();
        aFormData.append("users_methods", '__update_profile__');
        aFormData.append("data", JSON.stringify(data));

        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + "account", aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    updateProfileImage(data, token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token

            }
        };

        let aFormData = new FormData();
        aFormData.append("users_methods", '__update_profile_image__');
        aFormData.append("data", JSON.stringify(data));

        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + "account", aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    updatePassword(data, token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token

            }
        };

        let aFormData = new FormData();
        aFormData.append("users_methods", '__update_password__');
        aFormData.append("data", JSON.stringify(data));

        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + "account", aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

}


export default api